export default ({ POST, GET, UPLOAD }) => ({
  GetBook: (...arg) => POST('/book/GetBook', ...arg),
  SaveBook: (...arg) => POST('/book/SaveBook', ...arg),
  DelBook: (...arg) => POST('/book/DelBook', ...arg),
})
